import MyNode from "images/noun-node-1902925.svg";
import AllNode from "images/noun-nodes-4246515.svg";
import AllRewards from "images/noun-value-1969733.svg";

import Appartment from "images/appartment.svg";
import Building from "images/building.svg";
import House from "images/house.svg";
import { RewardManagementContext } from "../context/RewardManagementContext";

 
import { Modal } from ".";
import { Loader } from ".";

import React, { useRef, useContext } from "react";
// import { BsInfoCircle } from 'react-icons/bs';
// import { AiFillPlayCircle } from 'react-icons/ai';

const Welcome = () => {
  const { totalNodes,totalHouse, totalBuilding, totalAppartment, myTotalNodes, myTotalRewards,myTotalFees, rewardsPerNode, nodes } =
    useContext(RewardManagementContext);  

  const [showModal, setShowModal] = React.useState(false);
  
  const openModal = () => {
    setShowModal((prev) => !prev);
  };
  
  return (
    <div className="w-full flex md:justify-center justify-between items-center p-4 ">
      <div className="flex  md:flex-row flex-col items-start justify-between md:p-20 py-10 ">
        <div className="flex flex-1 justify-start flex-col md:mr-10  ml-10 mr-10">
         
          
          <h1 className="text-3xl sm:text-3xl text-white text-gradient py-1">
            Welcome to MetaEstate <br />
          </h1>
          {/* md:w-9/12  w-11/12 */}
          <p className="text-left mt-5 text-white font-light  text-sm indent-8 text-justify">
            From this console, you can view, manage, and launch METAEST-nodes.
            You can also see how many rewards have been allocated, and claim
            them here. Then if you want, you can use them to create more
            MSTATE-nodes, up to a maximum of 100 per wallet.
          </p>
          <Modal showModal={showModal} setShowModal={setShowModal} />
          <div className="flex-row text-left mb-4">
            <a
              className="mt-5 relative inline-flex items-center justify-center btn"
              style={{ marginleft: "0px" }}
              href="#"
            >
              <span style={{ background: "rgb(44, 44, 44)" }}>GET $METAEST</span>
            </a>
            <a
              className="mt-5 relative inline-flex items-center justify-center btn"
              style={{ marginleft: "5px" }}
              href="#"
            >
              <span style={{ background: "rgb(44, 44, 44)" }}>DISCORD</span>
            </a>
          </div>

          <div className="bg-black rounded-lg p-4 shadow-xl text-white flex flex-row">
            <span className="flex flex-row m-2 ">
              Current rewards :
              <b className="ml-1 mr-1 gradiant-reward-text text-lg mr-2 ml-2">
                {rewardsPerNode}
              </b>
              per House node, per day.
            </span>
          </div>

          
        </div>

        <div className="flex flex-col flex-1  items-center justify-end w-full md:mt-0 mt-0">
          <div className="container  sm:w-96 w-full ">
            <div className="box">
              <span></span>

              <div className="content flex flex-row">
                <img
                  src={MyNode}
                  alt="logo"
                  className="cursor-pointer mr-5 mb-3 "
                  style={{ color: "white" }}
                />
                <div className="mt-3">
                  <h2> {myTotalNodes} / 100 Max</h2>
                  <p className="">My Nodes</p>
                </div>
              </div>
              <a className="btn" onClick={openModal} href="#">
                <span>Create Node</span>
              </a>
            </div>

            <div className="box">
              <span></span>
              <div className="content ">
                <div className="flex flex-row">
                  <div className="w-40 allNods flex-col text-center ">
                    <img
                      src={AllNode}
                      alt="logo"
                      className="cursor-pointer"
                      style={{ color: "white" }}
                    />
                    <div>
                      <h2> {totalNodes} </h2>
                      <p className="text-center ">All Nodes</p>
                    </div>
                  </div>

                  <div className="flex flex-col ">
                    <div className="nodeItem">
                      <img
                        src={House}
                        alt="logo"
                        className="cursor-pointer "
                        style={{ color: "white" }}
                      />
                      <div className="nodeTotal">
                        <h2> {totalHouse} </h2>
                        <p className=" ">House</p>
                      </div>
                    </div>

                    <div className="nodeItem">
                      <img
                        src={Building}
                        alt="logo"
                        className="cursor-pointer "
                        style={{ color: "white", width: "600px" }}
                      />
                      <div className="nodeTotal">
                        <h2> {totalBuilding} </h2>
                        <p className=" ">Building</p>
                      </div>
                    </div>

                    <div className="nodeItem">
                      <img
                        src={Appartment}
                        alt="logo"
                        className="cursor-pointer "
                        style={{ color: "white" }}
                      />
                      <div className="nodeTotal">
                        <h2> {totalAppartment} </h2>
                        <p className=" ">Appartment</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="box">
              <span>
              <div className="content columns-4">
                <div className="">
                  <img
                    src={AllRewards}
                    alt="logo"
                    className="cursor-pointer"
                    style={{ color: "white", width: "80px" }}
                  />
                </div>
                <div className="pt-[12px]">
                  
                  <div className="gap-8 columns-2 ">
                    <h2
                      className=" gradiant-reward-text w-48 "
                      style={{ fontsize: "30px" }}
                    >
                      {" "}
                      {myTotalRewards}{" "}
                    </h2>
                    <h2 className="ml-[130px] w-24 " style={{ fontsize: "15px" }}>
                      {" "}
                      METAEST{" "}
                    </h2>
                  </div>
                  <p className="">My Reward</p>
                </div>
              </div>
              </span>              
            </div>
            <div className="box">
              <span>
              <div className="content columns-4">
                <div className="">
                  <img
                    src={AllRewards}
                    alt="logo"
                    className="cursor-pointer"
                    style={{ color: "white", width: "80px" }}
                  />
                </div>
                <div className="pt-[12px]">
                  
                  <div className="gap-8 columns-2 ">
                    <h2
                      className=" gradiant-reward-text w-48 "
                      style={{ fontsize: "30px" }}
                    >
                      {" "}
                      {myTotalFees}{" "}
                    </h2>
                    <h2 className="ml-[130px] w-24 " style={{ fontsize: "15px" }}>
                      {" "}
                      METAEST{" "}
                    </h2>
                  </div>
                  <p className="">Total Fee</p>


                </div>
              </div>
              </span>

              
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};
export default Welcome;
